import React, { PropsWithChildren, useEffect, useState } from 'react'
import { Typography, Box } from '@material-ui/core'
import styled from 'styled-components'
import { CustomTable } from '../eventManagement/CustomTable'
import moment from 'moment'
import { useAdminReportedList } from 'pages/administration/hooks/reported-list/useAdminReportedList'
import { observer } from 'mobx-react'
import { ReportedContentState } from 'models/reported-content/reported-content.store'

const StyledEndText = styled(Typography)`
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  color: ${props => props.theme.colors.accent1};
  padding-top: 0.938rem;
`
const StyledActivityLogBox = styled(Box)`
  && {
    margin-top: 2rem;
    margin-bottom: 2rem;
    height: 40vh
    z-index: 0;
    .MuiTableBody-root {
        height: 5vh;
    }
  }
`
const StyledActivityLogHeader = styled(Typography)`
  && {
    font-weight: bold;
    margin-bottom: 1rem;
    font-size: 18px;
  }
`

const ReportedLogs = () => {
  const { reportLogs, reportedContent, isReportLogReady, reportLogPage, setReportLogPage } = ReportedContentState

  const totalCountReportLogs = parseInt(reportLogs?.totalCount)
  
  const fetchMoreReportLogs = () => {
    setReportLogPage(reportLogPage + 1) 
  }

  return (
    <StyledActivityLogBox>
            <StyledActivityLogHeader>Report Logs</StyledActivityLogHeader>
            <CustomTable 
              columns={[
                {
                  name: 'Date',
                  propName: 'createdAt',
                  preprocessor(value, row) {
                    return moment(value).format('DD/MM/YYYY')
                  }
                },
                {
                  name: 'Reporter',
                  propName: '',
                  preprocessor(value, row, index) {
                    return <>{`${row?.reporterFirstName} ${row?.reporterLastName}`}</>
                  },
                  
                },               
                {
                  name: 'Category',
                  propName: 'reportReason'
                },
              ]} 
              height={'35vh'} 
              data={reportLogs?.data} 
              onReachedBottom={() => fetchMoreReportLogs()}
                  showLoader={totalCountReportLogs > reportLogs?.data.length}
                  showNoMoreText={totalCountReportLogs <= reportLogs?.data.length}
                  noMoreText={
                    <StyledEndText>{totalCountReportLogs === 0 && 'No Activity logs found'}</StyledEndText>
              }
              isReady={isReportLogReady}
              />
          </StyledActivityLogBox>
  )
}

export default observer(ReportedLogs)
